
<template>
  <main class="w-full max-w-none">
    <div class="mx-auto w-full max-w-full px-0">
      <div class="mb-8">
        <h1 class="text-2xl md:text-3xl font-bold text-gray-900 mb-2">{{ title }}</h1>
        <AdvancedFeatureNotice :api-url="apiPath" />
        <p class="text-gray-600">{{ description }}</p>
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-5 gap-3 w-full">
        <!-- 左侧内容 -->
        <div class="w-full lg:col-span-3">
          <Card class="mb-8">
            <CardHeader>
              <CardTitle>接口说明</CardTitle>
              <CardDescription></CardDescription>
            </CardHeader>
            <CardContent>
              <div class="flex items-center gap-4 mb-6 p-4 bg-gray-50 rounded-lg">
                <span class="px-3 py-1 bg-green-100 text-green-800 text-sm font-medium rounded-full">POST</span>
                <code class="text-sm font-mono">{{ apiPath }}</code>
              </div>

              <div class="space-y-6">
                
          <div>
            <h3 class="text-lg font-medium text-gray-900 mb-3">请求头参数</h3>
            <div class="overflow-x-auto">
              <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">参数名</th>
                    <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">类型</th>
                    <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">必需</th>
                    <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">描述</th>
                    <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">示例值</th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  
                  <tr>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">x-app-id</td>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">String</td>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">是</td>
                    <td class="px-3 md:px-6 py-4 text-sm text-gray-500">APP ID</td>
                    <td class="px-3 md:px-6 py-4 text-sm text-gray-500">4d9414e89bc24b0d89b678d9f20bc56a</td>
                  </tr>
                  
                
                  <tr>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">x-app-secret</td>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">String</td>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">是</td>
                    <td class="px-3 md:px-6 py-4 text-sm text-gray-500">API Key</td>
                    <td class="px-3 md:px-6 py-4 text-sm text-gray-500">8201e508ef948b8fcdca855729e7ee34</td>
                  </tr>
                  
                
                  <tr>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">x-customer-code</td>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">String</td>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">是</td>
                    <td class="px-3 md:px-6 py-4 text-sm text-gray-500">客户编号</td>
                    <td class="px-3 md:px-6 py-4 text-sm text-gray-500">CUSTFA48DD8EFF437956</td>
                  </tr>
                  
                
                  <tr>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">Content-Type</td>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">String</td>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">是</td>
                    <td class="px-3 md:px-6 py-4 text-sm text-gray-500">发送内容类型</td>
                    <td class="px-3 md:px-6 py-4 text-sm text-gray-500">application/json</td>
                  </tr>
                  
                
                </tbody>
              </table>
            </div>
          </div>
                
          <div>
            <h3 class="text-lg font-medium text-gray-900 mb-3">请求参数</h3>
            <div class="overflow-x-auto">
              <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">参数名</th>
                    <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">类型</th>
                    <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">必需</th>
                    <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">描述</th>
                    <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">示例值</th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  
                  <tr>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">businessTransNo</td>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">String</td>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">是</td>
                    <td class="px-3 md:px-6 py-4 text-sm text-gray-500">外部交易流水号，注：业务唯一编号，长度&lt;=100</td>
                    <td class="px-3 md:px-6 py-4 text-sm text-gray-500">BGP202609020001</td>
                  </tr>
                  
                
                  <tr>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">list</td>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">Array</td>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">否</td>
                    <td class="px-3 md:px-6 py-4 text-sm text-gray-500">收款列表，最大5000，每家银行支持的最大值不同</td>
                    <td class="px-3 md:px-6 py-4 text-sm text-gray-500"></td>
                  </tr>
                  
                  <tr>
                    <td colspan="5" class="px-3 md:px-6 py-4">
                      <div class="ml-6">
                        <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                          <thead class="bg-gray-50">
                            <tr>
                              <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">字段名</th>
                              <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">类型</th>
                              <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">必需</th>
                              <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">描述</th>
                              <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">示例值</th>
                            </tr>
                          </thead>
                          <tbody class="bg-white divide-y divide-gray-200">
                            
                              <tr>
                                <td class="px-6 py-2 text-sm">itemTransNo</td>
                                <td class="px-6 py-2 text-sm text-gray-500">String</td>
                                <td class="px-6 py-2 text-sm text-gray-500">否</td>
                                <td class="px-6 py-2 text-sm text-gray-500">外部明细交易流水号，业务方维度全局唯一，长度≤100，同时属于这一条明细的明细流水号</td>
                                <td class="px-6 py-2 text-sm text-gray-500">BGP202609020001-001</td>
                              </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                
                </tbody>
              </table>
            </div>
          </div>
                
                
                
          <div>
            <h3 class="text-lg font-medium text-gray-900 mb-3">响应参数</h3>
            <div class="overflow-x-auto">
              <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">参数名</th>
                    <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">类型</th>
                    <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">描述</th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  
                  <tr>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">code</td>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">String</td>
                    <td class="px-3 md:px-6 py-4 text-sm text-gray-500">返回码：200 或 400</td>
                  </tr>


                  <tr>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">data.businessTransNo</td>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">String</td>
                    <td class="px-3 md:px-6 py-4 text-sm text-gray-500">外部交易流水号，注：业务唯一编号，长度&lt;=100</td>
                  </tr>
               
                  <tr>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">data.exceptionMessage</td>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">String</td>
                    <td class="px-3 md:px-6 py-4 text-sm text-gray-500">异常信息，当汇总单状态交易失败或者交易结果未知时返回</td>
                  </tr>
                  
                
                  <tr>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">data.list</td>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">Array</td>
                    <td class="px-3 md:px-6 py-4 text-sm text-gray-500">列表，最大5000，每家银行支持的最大值不同</td>
                  </tr>
                  
                  <tr>
                    <td colspan="3" class="px-3 md:px-6 py-4">
                      <div class="ml-6">
                        <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                          <thead class="bg-gray-50">
                            <tr>
                              <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">字段名</th>
                              <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">类型</th>
                              <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">描述</th>
                            </tr>
                          </thead>
                          <tbody class="bg-white divide-y divide-gray-200">
                            
                              <tr>
                                <td class="px-6 py-2 text-sm">itemExceptionMessage</td>
                                <td class="px-6 py-2 text-sm text-gray-500">String</td>
                                <td class="px-6 py-2 text-sm text-gray-500">明细异常信息，当明细支付状态失败或者交易结果未知时返回</td>
                              </tr>
                              <tr>
                                <td class="px-6 py-2 text-sm">itemTransNo</td>
                                <td class="px-6 py-2 text-sm text-gray-500">String</td>
                                <td class="px-6 py-2 text-sm text-gray-500">外部明细交易流水号，业务方维度全局唯一，≤100\n同时属于这一条明细的明细流水号</td>
                              </tr>
                              <tr>
                                <td class="px-6 py-2 text-sm">itemTranserMessage</td>
                                <td class="px-6 py-2 text-sm text-gray-500">String</td>
                                <td class="px-6 py-2 text-sm text-gray-500">明细状态描述</td>
                              </tr>
                              <tr>
                                <td class="px-6 py-2 text-sm">itemTransferStatus</td>
                                <td class="px-6 py-2 text-sm text-gray-500">String</td>
                                <td class="px-6 py-2 text-sm text-gray-500">明细状态：交易成功，交易失败，交易结果未知</td>
                              </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                
                  <tr>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">data.paySerialNo</td>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">String</td>
                    <td class="px-3 md:px-6 py-4 text-sm text-gray-500">内部交易流水号，资金系统返回</td>
                  </tr>
                  
                
                  <tr>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">data.transferMessage</td>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">String</td>
                    <td class="px-3 md:px-6 py-4 text-sm text-gray-500">汇总状态描述</td>
                  </tr>
                  
                
                  <tr>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">data.transferStatus</td>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">String</td>
                    <td class="px-3 md:px-6 py-4 text-sm text-gray-500">汇总状态：待发送指令，银行处理中，交易成功，交易失败，交易结果未知，部分结果未知，部分失败</td>
                  </tr>
                  
                
                  <tr>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">message</td>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">String</td>
                    <td class="px-3 md:px-6 py-4 text-sm text-gray-500">描述信息</td>
                  </tr>
                  
                
                  <tr>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">realJsonModel</td>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">String</td>
                    <td class="px-3 md:px-6 py-4 text-sm text-gray-500">返回数据结构 是否json数据</td>
                  </tr>
                  
                
                  <tr>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">status</td>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">String</td>
                    <td class="px-3 md:px-6 py-4 text-sm text-gray-500">http状态码</td>
                  </tr>
                  
                
                  <tr>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">successResponse</td>
                    <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">Boolean</td>
                    <td class="px-3 md:px-6 py-4 text-sm text-gray-500">是否成功</td>
                  </tr>
                  
                
                </tbody>
              </table>
            </div>
          </div>


          <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    支付结果状态码
                  </h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            状态码
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            描述
                          </th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            X5888
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            银行受理成功（不代表交易成功，最终付款状态以最终网银出账为准）
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            X4445
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            待发送付款指令
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            X5554
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            支付单不存在
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            X5555
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            银行处理中
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            X5558
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            部分受理失败
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            X9999
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            银行受理失败
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- 响应示例（暂时注释）
                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">响应示例</h3>
                  <div class="border rounded-lg overflow-hidden">
                    <div class="bg-gray-800 text-gray-200 px-4 py-2 text-sm font-medium">JSON</div>
                    <pre class="p-4 bg-gray-900 text-gray-100 text-sm overflow-x-auto"><code>{
	"code": "200",
	"data": {
		"transferStatus": "P0000",
		"transferMessage": "支付成功",
		"paySerialNo": "BEC-2510241115150001",
		"businessTransNo": "TRANS2025102400013",
		"list": [
			{
				"itemTransNo": "TRANS2025102400014",
				"itemTransferStatus": "P0000",
				"itemTranserMessage": "支付成功",
				"itemExceptionMessage":""
			}
		]
	},
	"message": "支付成功",
	"realJsonModel": "true",
	"status": "200",
	"successResponse": true
}</code></pre>
                  </div>
                </div>
                -->
              </div>
            </CardContent>
          </Card>
        </div>

        <!-- 右侧内容：试一试 -->
        <div class="w-full lg:col-span-2">
          <Card>
            <CardHeader>
              <CardTitle>试一试</CardTitle>
              <CardDescription>使用不同语言测试API</CardDescription>
            </CardHeader>
            <CardContent>
              <div class="border-b border-gray-200">
                <nav class="-mb-px flex space-x-8 overflow-x-auto">
                  <button v-for="language in languages" :key="language.id" @click="activeLanguage = language.id" class="whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm" :class="[activeLanguage === language.id ? 'border-[var(--primary)] text-[var(--primary)]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300']">
                    {{ language.name }}
                  </button>
                </nav>
              </div>

              <div class="mt-6">
                <pre class="bg-gray-800 text-gray-100 p-4 rounded-md text-sm overflow-x-auto"><code :class="codeClass">{{ getRequestText() }}</code></pre>
                <div class="space-y-4">
                  
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">x-app-id <span class="text-red-500">*</span></label>
                      <input v-model="xAppId" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500" />
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">x-app-secret <span class="text-red-500">*</span></label>
                      <input v-model="xAppSecret" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500" />
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">x-customer-code <span class="text-red-500">*</span></label>
                      <input v-model="xCustomerCode" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500" />
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">Content-Type <span class="text-red-500">*</span></label>
                      <input v-model="ContentType" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500" />
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">businessTransNo </label>
                      <input v-model="businessTransNo" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500" />
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">list </label>
                      <input v-model="list" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500" />
                    </div>
                  <button @click="sendRequest" :disabled="loading" class="w-full bg-[var(--primary)] hover:bg-[color:var(--primary)] text-white font-medium py-2 px-4 rounded-md transition duration-200 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed">
                    {{ loading ? '请求中...' : '发送请求' }}
                  </button>
                </div>
              </div>

              <div v-if="response" class="mt-6">
                <h3 class="text-lg font-medium text-gray-900 mb-2">响应结果</h3>
                <pre class="bg-gray-800 text-gray-100 p-4 rounded-md text-sm overflow-x-auto"><code class="language-json">{{ response }}</code></pre>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, nextTick, watch } from 'vue'
import Card from '@/components/ui/Card.vue'
import CardHeader from '@/components/ui/CardHeader.vue'
import CardTitle from '@/components/ui/CardTitle.vue'
import CardDescription from '@/components/ui/CardDescription.vue'
import CardContent from '@/components/ui/CardContent.vue'
import AdvancedFeatureNotice from '@/components/ui/AdvancedFeatureNotice.vue'
import { useCodeHighlight } from '@/composables/useCodeHighlight'
import httpService from '@/lib/http'
import hljs from 'highlight.js/lib/core'

const props = defineProps<{
  title: string
  apiPath: string
  description: string
}>()

const serverUrl = (import.meta.env.VITE_API_URL as string) || 'https://sandbox-qa.nexbankapi.com'
const apiUrl = computed(() => `${serverUrl}${props.apiPath}`)

// 代码高亮
useCodeHighlight('pre code')

// 使用代码高亮（按语言映射）
const highlightCode = () => {
  nextTick(() => {
    setTimeout(() => {
      const allCodeBlocks = document.querySelectorAll('pre code')
      const languageMap: Record<string, string> = {
        curl: 'language-bash',
        javascript: 'language-javascript',
        python: 'language-python',
        java: 'language-java',
        csharp: 'language-csharp',
        php: 'language-php',
        ruby: 'language-ruby',
      }
      const langClass = languageMap[activeLanguage.value]
      allCodeBlocks.forEach((block) => {
        const el = block as HTMLElement
        el.className = ''
        el.removeAttribute('data-highlighted')
        el.classList.add('hljs')
        if (langClass) el.classList.add(langClass)
        try {
          hljs.highlightElement(el)
        } catch (error) {
          console.warn('代码高亮失败:', error)
        }
      })
    }, 100)
  })
}
// 初始化代码高亮
highlightCode()

// 状态
const loading = ref(false)
const response = ref('')
const languagesAll = ['curl', 'javascript', 'python', 'java', 'csharp', 'php', 'ruby'] as const
 type LanguageId = typeof languagesAll[number]
 const activeLanguage = ref<LanguageId>('curl')
 const languages = [
   { id: 'curl' as LanguageId, name: 'cURL' },
   { id: 'javascript' as LanguageId, name: 'JavaScript' },
   { id: 'python' as LanguageId, name: 'Python' },
   { id: 'java' as LanguageId, name: 'Java' },
   { id: 'csharp' as LanguageId, name: 'C#' },
   { id: 'php' as LanguageId, name: 'PHP' },
   { id: 'ruby' as LanguageId, name: 'Ruby' }
 ]

const xAppId = ref('登录后自动获取')
const xAppSecret = ref('登录后自动获取')
const xCustomerCode = ref('登录后自动获取')
const ContentType = ref('application/json')
const businessTransNo = ref('BGP202609020001')
const list = ref('')

const resolveListPayload = (): unknown[] | undefined => {
  const raw = String(list.value ?? "").trim()
  if (!raw) return undefined
  try {
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed : [parsed]
  } catch {
    return [{ itemTransNo: raw }]
  }
}

const headersMap = computed<Record<string, string>>(() => ({ 'x-app-id': xAppId.value, 'x-app-secret': xAppSecret.value, 'x-customer-code': xCustomerCode.value, 'Content-Type': ContentType.value }))
const bodyMap = computed(() => {
  const payload: Record<string, unknown> = {
    businessTransNo: businessTransNo.value,
  }
  const listPayload = resolveListPayload()
  if (listPayload !== undefined) {
    payload.list = listPayload
  }
  return payload
})
const bodyMapAsSearchParams = () =>
  new URLSearchParams(
    Object.entries(bodyMap.value)
      .filter(([, value]) => value !== undefined && value !== '')
      .map(([key, value]) => [key, String(value)])
  ).toString()
const queryMap = computed<Record<string, string>>(() => ({  }))

// 登录后自动填充应用与客户信息

// 获取应用信息
const getApplicationInfo = async () => {
  try {
    const response = await httpService.get<any>("/nxb/console/application/get");
    if (response) {
      return { appId: response.appId, appSecret: response.appSecret };
    }
    return null;
  } catch (error) {
    console.log("获取应用信息失败:", error);
    return null;
  }
};

// 获取客户信息
const getCustomerInfo = async () => {
  try {
    const response = await httpService.get<any>("/nxb/console/customer/listWithSummary", { pageNow: 1, pageSize: 10 });
    if (response) {
      return response.customers?.[0]?.customerCode;
    }
    return null;
  } catch (error) {
    console.log("获取客户信息失败:", error);
    return null;
  }
};

// 登录后自动获取用户信息
const autoFetchUserInfo = async () => {
  const userInfoStr = localStorage.getItem("userInfo");
  if (userInfoStr) {
    const appInfo = await getApplicationInfo();
    if (appInfo) {
      xAppId.value = appInfo.appId;
      xAppSecret.value = appInfo.appSecret;
    }
    const customerCodeValue = await getCustomerInfo();
    if (customerCodeValue) {
      xCustomerCode.value = customerCodeValue;
    }
  }
};

// 组件挂载时登录后自动获取用户信息
onMounted(() => {
  autoFetchUserInfo();
});


// 生成请求示例文本
const getRequestText = () => {

  switch (activeLanguage.value) {
    case 'curl': {
      const qs = new URLSearchParams(Object.entries(queryMap.value).filter(([_, v]) => v !== undefined && v !== '')).toString();
      let out = "curl -X POST '" + apiUrl.value + (qs ? "?" + qs : "") + "' \\\n";
out += "  -H 'x-app-id: " + xAppId.value + "' \\\n";
out += "  -H 'x-app-secret: " + xAppSecret.value + "' \\\n";
out += "  -H 'x-customer-code: " + xCustomerCode.value + "' \\\n";
out += "  -H 'Content-Type: " + ContentType.value + "' \\\n";
out += "  -H 'Content-Type: application/json' \\\n";
           out += "  -d '" + JSON.stringify(bodyMap.value) + "'";
      return out;
    }
    case 'javascript': {
      const qs = new URLSearchParams(Object.entries(queryMap.value).filter(([_, v]) => v !== undefined && v !== '')).toString();
      let js = "const axios = require('axios');\n\n";
      if (true) {
        if (false) {
          js += "const data = new URLSearchParams({\n";
          Object.entries(bodyMap.value).forEach(([k, v]) => {
            if (v !== undefined && v !== '') {
              js += "  '" + k + "': \"" + v + "\",\n";
            }
          });
          js += "});\n\n";
        } else {
          js += "const data = " + JSON.stringify(bodyMap.value, null, 2) + ";\n\n";
        }
      } else {
        js += "const data = undefined;\n\n";
      }

      js += "const config = {\n";
      js += "  method: 'post',\n";
      js += "  url: '" + apiUrl.value + (qs ? "?" + qs : "") + "',\n";
      js += "  headers: {\n";
      Object.entries(headersMap.value).forEach(([k, v]) => {
        if (v !== undefined && v !== '') {
          js += "      '" + k + "': \"" + v + "\",\n";
        }
      });
      js += "      'Content-Type': 'application/json'\n";
      js += "  },\n";
      js += "  data: data\n";
      js += "};\n\n";
      js += "axios(config)\n";
      js += "  .then(function (response) {\n";
      js += "    console.log(JSON.stringify(response.data));\n";
      js += "  })\n";
      js += "  .catch(function (error) {\n";
      js += "    console.log(error);\n";
      js += "  });";
      return js;
    }
    case 'python': {
      const qs = new URLSearchParams(Object.entries(queryMap.value).filter(([_, v]) => v !== undefined && v !== '')).toString();
      const fullUrl = apiUrl.value + (qs ? "?" + qs : "");
      let py = "import requests\nimport json\n\n";
      py += "url = \"" + fullUrl + "\"\n\n";
      py += "payload = json.dumps(" + JSON.stringify(bodyMap.value) + ")\n";
      py += "headers = {\n";
      Object.entries(headersMap.value).forEach(([k, v]) => {
        if (v !== undefined && v !== '') {
          py += "  '" + k + "': \"" + v + "\",\n";
        }
      });
      py += "  'Content-Type': 'application/json'\n";
      py += "}\n\n";
      py += "response = requests.request(\"POST\", url, headers=headers, data=payload)\n\n";
      py += "print(response.text)";
      return py;
    }
        case 'java': {
      const qs = new URLSearchParams(Object.entries(queryMap.value).filter(([_, v]) => v !== undefined && v !== '')).toString();
      const fullUrl = apiUrl.value + (qs ? "?" + qs : "");
      let payload = "";
      if (true) {
        if (false) {
          payload = bodyMapAsSearchParams();
        } else {
          payload = JSON.stringify(Object.fromEntries(Object.entries(bodyMap.value).filter(([_, v]) => v !== undefined && v !== '')));
        }
      }
      let java = "OkHttpClient client = new OkHttpClient().newBuilder()\n";
      java += "  .build();\n";
      java += "MediaType mediaType = MediaType.parse(\"" + (true ? "application/json" : "text/plain") + "\");\n";
      java += "RequestBody body = RequestBody.create(mediaType, \"" + (payload || "").replace(/"/g, '\\"') + "\");\n";
      java += "Request request = new Request.Builder()\n";
      java += "  .url(\"" + fullUrl + "\")\n";
      java += "  .method(\"" + "POST" + "\", " + (true ? "body" : "null") + ")\n";
      Object.entries(headersMap.value).forEach(([k, v]) => {
        if (v !== undefined && v !== '') {
          java += "  .addHeader(\"" + k + "\", \"" + v + "\")\n";
        }
      });
      java += "  .addHeader(\"Content-Type\", \"application/json\")\n";
      java += "  .build();\n";
      java += "Response response = client.newCall(request).execute();";
      return java;
    }
    case 'csharp': {
      const qs = new URLSearchParams(Object.entries(queryMap.value).filter(([_, v]) => v !== undefined && v !== '')).toString();
      const fullUrl = apiUrl.value + (qs ? "?" + qs : "");
      let payload = "";
      if (true) {
        if (false) {
          payload = bodyMapAsSearchParams();
        } else {
          payload = JSON.stringify(Object.fromEntries(Object.entries(bodyMap.value).filter(([_, v]) => v !== undefined && v !== '')));
        }
      }
      let cs = "";
      cs += "var client = new RestClient(\"" + fullUrl + "\");\n";
      cs += "var request = new RestRequest(Method." + "POST" + ");\n";
      Object.entries(headersMap.value).forEach(([k, v]) => {
        if (v !== undefined && v !== '') {
          cs += "request.AddHeader(\"" + k + "\", \"" + v + "\");\n";
        }
      });
      if (true) {
        cs += "request.AddHeader(\"Content-Type\", \"" + "application/json" + "\");\n";
        cs += "request.AddParameter(\"" + "application/json" + "\", \"" + (payload || "").replace(/"/g, '\\"') + "\", ParameterType.RequestBody);\n";
      }
      cs += "IRestResponse response = client.Execute(request);\n";
      cs += "Console.WriteLine(response.Content);";
      return cs;
    }
    case 'php': {
      const qs = new URLSearchParams(Object.entries(queryMap.value).filter(([_, v]) => v !== undefined && v !== '')).toString();
      const fullUrl = apiUrl.value + (qs ? "?" + qs : "");
      let payload = "";
      if (true) {
        if (false) {
          payload = bodyMapAsSearchParams();
        } else {
          payload = JSON.stringify(Object.fromEntries(Object.entries(bodyMap.value).filter(([_, v]) => v !== undefined && v !== '')));
        }
      }
      let php = "<?php\n\n";
      php += "$curl = curl_init();\n\n";
      php += "curl_setopt_array($curl, array(\n";
      php += "  CURLOPT_URL => '" + fullUrl.replace(/'/g, "\'") + "',\n";
      php += "  CURLOPT_RETURNTRANSFER => true,\n";
      php += "  CURLOPT_ENCODING => '',\n";
      php += "  CURLOPT_MAXREDIRS => 10,\n";
      php += "  CURLOPT_TIMEOUT => 0,\n";
      php += "  CURLOPT_FOLLOWLOCATION => true,\n";
      php += "  CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,\n";
      php += "  CURLOPT_CUSTOMREQUEST => '" + "POST" + "',\n";
      if (true) {
        php += "  CURLOPT_POSTFIELDS => '" + (payload || "").replace(/"/g, '\\"').replace(/'/g, "\'") + "',\n";
      }
      php += "  CURLOPT_HTTPHEADER => array(\n";
      Object.entries(headersMap.value).forEach(([k, v]) => {
        if (v !== undefined && v !== '') {
          php += "    '" + k + ": " + String(v).replace(/"/g, '\\"').replace(/'/g, "\'") + "',\n";
        }
      });
      php += "    'Content-Type: application/json',\n";
      php += "  ),\n";
      php += "));\n\n";
      php += "$response = curl_exec($curl);\n\n";
      php += "curl_close($curl);\n";
      php += "echo $response;";
      return php;
    }
    case 'ruby': {
      const qs = new URLSearchParams(Object.entries(queryMap.value).filter(([_, v]) => v !== undefined && v !== '')).toString();
      const fullUrl = apiUrl.value + (qs ? "?" + qs : "");
      let payload = "";
      if (true) {
        if (false) {
          payload = bodyMapAsSearchParams();
        } else {
          payload = JSON.stringify(Object.fromEntries(Object.entries(bodyMap.value).filter(([_, v]) => v !== undefined && v !== '')));
        }
      }
      let ruby = "require 'net/http'\nrequire 'uri'\n\n";
      ruby += "uri = URI.parse(\"" + fullUrl + "\")\n";
      ruby += "http = Net::HTTP.new(uri.host, uri.port)\n";
      ruby += "http.use_ssl = (uri.scheme == 'https')\n";
      ruby += "req = Net::HTTP::GenericRequest.new(\"" + "POST" + "\", " + (true ? "true" : "false") + ", true, uri.request_uri)\n";
      Object.entries(headersMap.value).forEach(([k, v]) => {
        if (v !== undefined && v !== '') {
          ruby += "req[\"" + k + "\"] = \"" + v + "\"\n";
        }
      });
      ruby += "req['Content-Type'] = \"application/json\"\n";
      if (true) {
        ruby += "req.body = \"" + (payload || "").replace(/"/g, '\\\"') + "\"\n";
      }
      ruby += "response = http.request(req)\n";
      ruby += "puts response.body\n";
      return ruby;
    }
    default:
      return ''
  }
}

// 代码块语言高亮类
const codeClass = computed(() => {
  const map: Record<LanguageId, string> = {
    curl: 'language-bash',
    javascript: 'language-javascript',
    python: 'language-python',
    java: 'language-java',
    csharp: 'language-csharp',
    php: 'language-php',
    ruby: 'language-ruby'
  }
  return map[activeLanguage.value]
})


// 监听响应式变量变化，重新应用代码高亮
watch(
  [activeLanguage, response, xAppId, xAppSecret, xCustomerCode],
  () => {
    highlightCode()
  },
  { flush: 'post' }
)


// 发送请求
const sendRequest = async () => {
  loading.value = true
  response.value = ''
  try {
    // 构造URL（附加query）
    const qs = new URLSearchParams(Object.entries(queryMap.value).filter(([,v]) => v !== undefined && v !== '')).toString()
    const url = qs ? apiUrl.value + '?' + qs : apiUrl.value

    // 构造Headers
    const headers: Record<string, string> = {}
    for (const [k, v] of Object.entries(headersMap.value)) {
      if (v !== undefined && v !== '') headers[k] = v
    }
    // Content-Type
    headers['Content-Type'] = 'application/json'

    // 构造Body
    let bodyData: any = undefined
    bodyData = JSON.stringify(bodyMap.value)

    const res = await fetch(url, {
      method: 'POST',
      headers,
      body: bodyData,
    })

    // 检查响应的Content-Type来决定如何处理响应
    const contentType = res.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      const data = await res.json()
      response.value = JSON.stringify(data, null, 2)
    } else {
      // 如果不是JSON响应，获取文本内容
      const text = await res.text()
      // 尝试解析为JSON，如果失败则显示原始文本
      try {
        const data = JSON.parse(text)
        response.value = JSON.stringify(data, null, 2)
      } catch {
        // 如果解析失败，显示原始文本和状态信息
        response.value = JSON.stringify({ 
          status: res.status,
          statusText: res.statusText,
          contentType: contentType || 'unknown',
          content: text 
        }, null, 2)
      }
    }
  } catch (error: any) {
    response.value = JSON.stringify({ error: '请求失败: ' + (error?.message || '未知错误') }, null, 2)
  } finally {
    loading.value = false
  }
}
</script>
